export enum UserRole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  MODERATOR = 'moderator',
  SUPPORT = 'support',
}

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'Super Admin',
  [UserRole.ADMIN]: 'Admin',
  [UserRole.MODERATOR]: 'Moderator',
  [UserRole.SUPPORT]: 'Support',
}

export const USER_ROLE_COLORS: Record<UserRole, string> = {
  [UserRole.SUPER_ADMIN]: 'danger',
  [UserRole.ADMIN]: 'warning',
  [UserRole.MODERATOR]: 'primary',
  [UserRole.SUPPORT]: 'info',
}
